import { render, staticRenderFns } from "./CheckAndEditStudent.vue?vue&type=template&id=5ce5b6d6&scoped=true&"
import script from "./CheckAndEditStudent.vue?vue&type=script&lang=js&"
export * from "./CheckAndEditStudent.vue?vue&type=script&lang=js&"
import style0 from "./CheckAndEditStudent.vue?vue&type=style&index=0&id=5ce5b6d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5b6d6",
  null
  
)

export default component.exports